import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Cross } from '@blueprintjs/icons'
import ReactDOMServer from 'react-dom/server'
import hexToRgba from 'hex-to-rgba'

import inlineStyles from './inlineStyles'
import Toolbar from '@client/components/Toolbar/index'
import {
  BlockModel,
  NULL as BlockModelNULL,
} from '@client/components/Block/model'
import TableInner from './FlexContainerInner'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import {
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  WIZARD_TYPE_PAGE,
  BUTTON_BORDER_STYLES,
} from '@client/components/Editor/settings'
import {
  SECTION_LAYOUTS,
  SECTION_TYPES,
  TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES,
  SECTION_WIDTH_TYPES_CLASS,
} from '@client/components/Section/constants'

@inject('app', 'editor', 'serverRender')
@observer
class FlexContainer extends Component {
  static propTypes = {
    bgcolor: PropTypes.string,
    border: PropTypes.string,
    align: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    model: PropTypes.instanceOf(BlockModel),
    serverRender: PropTypes.bool,
    editor: PropTypes.instanceOf(EditorModel),
    app: PropTypes.instanceOf(AppModel),
    count: PropTypes.number,
    index: PropTypes.number,
  }

  static defaultProps = {
    bgcolor: '',
    border: '0',
    align: 'center',
    width: '100%',
    className: 'section',
    model: BlockModelNULL,
    serverRender: false,
    editor: EditorModelNULL,
    app: AppModelNULL,
  }

  getBorderRadius = () => {
    const { editor, index, count } = this.props
    const borderRadius = editor.settings.values.popup_borderRadius
      ? `${editor.settings.values.popup_borderRadius}px`
      : undefined

    if (index === 0 && count === 1) {
      return borderRadius
    }

    if (index === 0 && count > 1) {
      return `${borderRadius} ${borderRadius} 0 0`
    }

    if (index === count - 1 && count > 1) {
      return `0 0 ${borderRadius} ${borderRadius}`
    }

    return undefined
  }

  render() {
    const { app, model, editor, count, width, className, serverRender } =
      this.props
    const settings = model.settings.values
    const isNewPage =
      app.wizard.type === WIZARD_TYPE_PAGE &&
      (editor.kind === ITEM_TYPE_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS) &&
      (model.sectionType === SECTION_TYPES.LANDINGONECOL ||
        model.sectionType === SECTION_TYPES.LANDINGTWOCOL)
    const backgroundColor =
      (model.isFullWidth && !isNewPage) ||
      (isNewPage && !settings.hasBackgroundImage && !model.isBoxed)
        ? settings.backgroundColor || editor.settings.values.contentColor
        : ''
    let backgroundImage =
      ((model.isFullWidth && !isNewPage) ||
        (isNewPage && model.isContentWidth)) &&
      settings.hasBackgroundImage
        ? settings.backgroundImageUrl || ''
        : ''

    if (backgroundImage) {
      if (
        editor.kind === ITEM_TYPE_FORM &&
        (model.settings.values.bgImagePosition ===
          TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES[0].value ||
          model.settings.values.bgImagePosition ===
            TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES[2].value)
      ) {
        backgroundImage = ''
      }
    }

    let tableCellStyles = {}

    if (backgroundImage) {
      tableCellStyles.backgroundPosition = 'center'
      tableCellStyles.backgroundSize = 'cover'
    }

    if (isNewPage) {
      let preparedClassName = ''
      let style = {
        ...tableCellStyles,
        backgroundColor: backgroundImage ? undefined : backgroundColor,
        backgroundImage: backgroundImage
          ? `url('${backgroundImage}')`
          : undefined,
        boxShadow:
          backgroundImage &&
          model.settings.values.hasBackgroundImageOverlay &&
          model.settings.values.backgroundColorOverlay
            ? `inset 0 0 0 100vmax ${hexToRgba(
                model.settings.values.backgroundColorOverlay
              )}`
            : undefined,
      }
      const maxWidthClass =
        SECTION_WIDTH_TYPES_CLASS[model.settings.values.widthType]
      if (model.settings.values.layout === SECTION_LAYOUTS[0].value) {
        preparedClassName = `${maxWidthClass} min-height relative ${
          count > 1
            ? `two-col ${
                model.settings.values.stackColumnsOnMobile ? 'stack' : ''
              }`
            : ''
        }`
        style.gap =
          typeof model.settings.values.middlePadding !== 'undefined'
            ? `${model.settings.values.middlePadding}px`
            : undefined
      } else if (model.settings.values.layout === SECTION_LAYOUTS[1].value) {
        preparedClassName = `content-background padding ${maxWidthClass} min-height relative ${
          count > 1 ? 'content-width-margin' : ''
        }`
        style = {
          ...style,
          ...model.borderStyles,
          ...model.borderRadiusStyles,
          paddingLeft:
            typeof model.settings.values.sidePadding !== 'undefined'
              ? `${model.settings.values.sidePadding}px`
              : undefined,
          paddingRight:
            typeof model.settings.values.sidePadding !== 'undefined'
              ? `${model.settings.values.sidePadding}px`
              : undefined,
        }
      } else if (model.settings.values.layout === SECTION_LAYOUTS[2].value) {
        preparedClassName = `${maxWidthClass} content-width-margin min-height relative `
      }
      return (
        <div
          className={`${preparedClassName} ${className}`}
          ref={(el) => (this.dom = el)}
          // ref={this.props.refpass}
          style={style}
        >
          <TableInner model={model} count={count} />
        </div>
      )
    }

    if (
      settings.borderStyle &&
      settings.borderStyle !== BUTTON_BORDER_STYLES[0].value &&
      model.isFullWidth
    ) {
      tableCellStyles = {
        ...tableCellStyles,
        ...model.borderStyles,
        ...model.borderRadiusStyles,
      }
    }

    return (
      <div
        className={className}
        style={inlineStyles.flexContainer}
        align="center"
        ref={(el) => (this.dom = el)}
        // ref={this.props.refpass}
      >
        <div
          className="gan-section"
          style={{
            ...tableCellStyles,
            width: width,
            backgroundColor: backgroundColor,
            backgroundImage: backgroundImage
              ? `url('${backgroundImage}')`
              : undefined,
            borderRadius: this.getBorderRadius(),
          }}
          align="center"
        >
          {model.sectionType !== SECTION_TYPES.FORMCOL &&
            model.sectionType !== SECTION_TYPES.FORMSUCCESSCOL &&
            editor.kind !== ITEM_TYPE_SURVEY && (
              <Toolbar model={model} count={count} />
            )}
          <div className="webkit" style={{ margin: '0 auto' }}>
            <TableInner model={model} count={count} />
            {model.sectionType === SECTION_TYPES.FORMCOL && (
              <div
                dangerouslySetInnerHTML={{
                  __html: `
                  <a
                    href="${
                      serverRender ? 'javascript:close()' : 'javascript:void(0)'
                    }"
                    class="close-popup"
                    style="position:absolute; right:10px; top: 10px; color: #000; background: rgba(255, 255, 255, .7); padding: 5px; border-radius: 100%;"
                  >
                    ${ReactDOMServer.renderToStaticMarkup(
                      <Cross />
                    )}
                  </a>`,
                }}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default FlexContainer
